import React, { useEffect, useState } from 'react';
import StyledBox from 'views/rebranded-module/events-module/MotorcycleEventsViewV2/MotorcycleEventsViewV2.style';
import axios, { API } from 'lib/config/axios';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import PATHS from 'lib/navigation/paths';
import Head from 'next/head';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { useSelector } from 'redux/app/store';
import { SLUGS_TYPES } from 'lib/utils/CONSTANTS';
import useRenderAiBot from 'views/common/hooks/useRenderAiBot';
import { PAGES_GA_IDENTIFIERS } from 'views/common/utils/constants';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import generateMetaData from 'lib/utils/generateMetaData';
import {
  HeroSection,
  EventsAndFilterSection,
  EventsAndFilterSectionSkeleton,
} from 'views/rebranded-module/events-module/MotorcycleEventsViewV2/components';
import { RiMapPinLine, RiCalendar2Fill } from 'react-icons/ri';
import { Box } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { LazyLoad } from 'views/common/components';

const MotorcycleEventsViewV2 = (props: any) => {
  const { slugParam, serverData, handleSlugTypeChange, slugName } = props;
  const handleErrorResponse = useErrorsHandler();
  const [loaded, setLoaded] = useState(!!serverData);
  const [data, setData] = useState(serverData);
  const { isSSR } = useSelector((state) => state.globalData);
  const getSizedImage = useAdabtiveMultiSizeImage();

  useRenderAiBot(true);
  const appNavigator = useAppNavigator();
  const cmsData = useContent();

  const extractArrayObject = (arrayOfObjects) => {
    const objectNames = arrayOfObjects.map((object) => ({
      id: object.id,
      name: object.name,
      slug: object.slug,
    }));
    return objectNames;
  };
  const extractFilterList = (object) => [
    {
      title: cmsData.EventsListingPage.allLocationsLabel,
      list: extractArrayObject(object.locations),
      selectedValue: object.selected_location?.name || null,
      type: SLUGS_TYPES.location,
      icon: <RiMapPinLine />,
    },
    {
      title: cmsData.EventsListingPage.allEventsLabel,
      list: extractArrayObject(object.event_types),
      selectedValue: object.selected_type?.name || null,
      type: SLUGS_TYPES.event_type,
      icon: <RiCalendar2Fill />,
      isLast: true,
    },
  ];

  const [filterLists, setFilterLists] = useState(
    serverData ? extractFilterList(serverData) : [],
  );
  const getData = (params = null) => {
    setLoaded(false);
    axios
      .get(API.events.index, {
        params: {
          ...params,
        },
      })
      .then((res) => {
        setData(res.data);
        setFilterLists(extractFilterList(res.data));
        setLoaded(true);
      })
      .catch((err) => {
        switch (err.response.status) {
          case 403:
            if (err.response.data.error_code === 'ER0001') {
              appNavigator.push(PATHS.motorcycleEvents.index());
            }
            break;
          default:
            handleErrorResponse(err, !!data);
        }
        if (data) {
          setLoaded(true);
        }
      });
  };
  const handleChangeEventsOrLocationsType = (e:any, type:string) => {
    const { list } = filterLists.find((filterList) => filterList.type === type);
    const slug = list.find((option) => option.name === e.target.value);
    handleSlugTypeChange({
      slugs: [{ slug: slug.slug, slug_type: type, resource_id: slug.id }],
    });
    if (slug.slug != null) {
      appNavigator.push(PATHS.motorcycleEvents.slug(slug.slug));
    } else {
      appNavigator.push(PATHS.motorcycleEvents.index());
    }
  };

  const handleEventCardCLick = (id:number|string, slug:string) => {
    handleSlugTypeChange({
      slugs: [{ slug, slug_type: SLUGS_TYPES.event, resource_id: id }],
    });
  };
  useEffect(() => {
    if (!isSSR) {
      if (!appNavigator.query.slug || slugName === appNavigator.query.slug) {
        getData(slugParam);
      }
    }
    window.gtag('event', 'landing_page_view', {
      page_identifier: PAGES_GA_IDENTIFIERS.EVENTS_LISTING,
    });
  }, [appNavigator.query.slug]);

  useEffect(() => {
    if (isSSR) {
      setData(serverData);
      setFilterLists(extractFilterList(serverData));
    }
  }, [serverData]);

  return (
    <StyledBox>
      {data?.seo_values && <Head>{generateMetaData(data.seo_values)}</Head>}
      <HeroSection
        selectedLocation={data.selected_location?.name}
        selectedEvent={data.selected_type?.name}
      />
      <Box className="MEVFilterAndListCointiner">
        <Box className="MEVBGPattern">
          <ImgBox
            image={{
              src: getSizedImage(cmsData.EventsListingPage.patternBackground),
              alt: cmsData.EventsListingPage.patternBackground.alt,
            }}
            width="100%"
            height="100%"
            unoptimized
          />
        </Box>
        <LazyLoad
          skeleton={<EventsAndFilterSectionSkeleton />}
          dataLoaded={loaded}>
          <EventsAndFilterSection
            handleChangeEventsOrLocationsType={
              handleChangeEventsOrLocationsType
            }
            filterLists={filterLists}
            events={data.events}
            handleEventCardCLick={handleEventCardCLick}
          />
        </LazyLoad>
      </Box>
    </StyledBox>
  );
};
export { MotorcycleEventsViewV2 };
